import Cookie from 'js-cookie'
import { initUUID } from "@t8891/helper";

export default function getUUID() {
  initUUID()

  return Cookie.get('uuid')
}
